import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { ViewProperties } from "../../../utils/ViewProperties";
/**
 * Properties for the game feature notepad.
 */
export class GameFeatureNotepadProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.notesPanelProperties = new PanelProperties();
        this.notesFadeAlpha = 0;
    }
}
//# sourceMappingURL=GameFeatureNotepadProperties.js.map